import { Button } from "antd";
import { useLoginWithLinkedin } from "Features/Auth/hooks/useLoginWithLinkedin";
import LoginModal from "Features/Navbar/LoginModal";
import { ArrowRight } from "lucide-react";
import { useState } from "react";

export function CtaSection() {
  const [loginModal, setLoginModal] = useState(false);
  const login = useLoginWithLinkedin();
  return (
    <section className="py-20 bg-primary/5">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="space-y-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-foreground">
            Ready to share your expertise and earn?
          </h2>

          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Join thousands of mentors helping students succeed while building
            your reputation and income (in future).
          </p>

          <Button
            className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg px-12 py-4"
            onClick={() => {
              setLoginModal(true);
            }}
          >
            Register Now
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>

          <LoginModal
            open={loginModal}
            onClose={() => setLoginModal(false)}
            onGoogleLogin={() => {}}
            onLinkedInLogin={() => {
              login();
              setLoginModal(false);
            }}
          />
        </div>
      </div>
    </section>
  );
}
